import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=3c3bd29d&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=ts&"
export * from "./Player.vue?vue&type=script&lang=ts&"
import style0 from "./Player.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Player.vue?vue&type=style&index=1&id=3c3bd29d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bd29d",
  null
  
)

export default component.exports